import { ActionIcon, Box, Group, Text } from '@mantine/core'
import { IconMinus, IconPlus } from '@tabler/icons-react'

interface QuantitySelectorProps {
  value: number
  onChange: (value: number) => void
  min?: number
  max?: number
  label?: string
}

export function QuantitySelector({ value, onChange, min = 1, max = 10, label }: QuantitySelectorProps) {
  return (
    <Box>
      {label && (
        <Text size="sm" weight={500} color="#374151" mb={8}>
          {label}
        </Text>
      )}
      <Group
        spacing={0}
        sx={{
          border: '1px solid #e5e7eb',
          borderRadius: 8,
          overflow: 'hidden',
          width: 'fit-content',
        }}
      >
        <ActionIcon
          size={40}
          variant="subtle"
          onClick={() => value > min && onChange(value - 1)}
          disabled={value <= min}
          sx={{
            borderRadius: 0,
            '&:hover': { background: '#f3f4f6' },
            '&:disabled': { background: '#f9fafb', color: '#d1d5db' },
          }}
        >
          <IconMinus size={16} />
        </ActionIcon>
        <Box
          sx={{
            width: 60,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 600,
            fontSize: 16,
            color: '#111827',
            background: '#fff',
          }}
        >
          {value}
        </Box>
        <ActionIcon
          size={40}
          variant="subtle"
          onClick={() => value < max && onChange(value + 1)}
          disabled={value >= max}
          sx={{
            borderRadius: 0,
            '&:hover': { background: '#f3f4f6' },
            '&:disabled': { background: '#f9fafb', color: '#d1d5db' },
          }}
        >
          <IconPlus size={16} />
        </ActionIcon>
      </Group>
    </Box>
  )
}
